import { OnChanges } from '@angular/core';
import { SpinnerColor, SpinnerSize, } from '@shared/ui/spinner/spinner.component';
export var ButtonColor;
(function (ButtonColor) {
    ButtonColor["SECONDARY"] = "secondary";
    ButtonColor["DEFAULT"] = "default";
    ButtonColor["SUCCESS"] = "success";
    ButtonColor["DANGER"] = "danger";
    ButtonColor["TRANSPARENT_DARK"] = "transparent-dark";
    ButtonColor["TRANSPARENT_LIGHT"] = "transparent-light";
    ButtonColor["PRIMARY"] = "primary";
})(ButtonColor || (ButtonColor = {}));
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["MINI"] = "mini";
    ButtonSize["SMALL"] = "small";
    ButtonSize["LARGE"] = "large";
    ButtonSize["XLARGE"] = "xlarge";
    ButtonSize["XXLARGE"] = "xxlarge";
})(ButtonSize || (ButtonSize = {}));
export var ButtonGroupPosition;
(function (ButtonGroupPosition) {
    ButtonGroupPosition["FIRST"] = "first";
    ButtonGroupPosition["MIDDLE"] = "middle";
    ButtonGroupPosition["LAST"] = "last";
})(ButtonGroupPosition || (ButtonGroupPosition = {}));
var ButtonComponent = /** @class */ (function () {
    function ButtonComponent() {
        this.SpinnerColor = SpinnerColor;
        this.SpinnerSize = SpinnerSize;
        this.buttonGroupFirst = false;
        this.buttonGroupMiddle = false;
        this.buttonGroupLast = false;
        this.display = 'inline';
        this.displayFlex = false;
        this.buttonType = 'button';
    }
    Object.defineProperty(ButtonComponent.prototype, "submit", {
        set: function (value) {
            this.buttonType = value ? 'submit' : 'button';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonComponent.prototype, "disabled", {
        get: function () {
            return !!this.attrDisabled;
        },
        set: function (value) {
            this.attrDisabled = value ? true : undefined;
        },
        enumerable: true,
        configurable: true
    });
    ButtonComponent.prototype.ngOnChanges = function () {
        if (this.buttonGroupPosition) {
            this.buttonGroupFirst =
                this.buttonGroupPosition === ButtonGroupPosition.FIRST;
            this.buttonGroupMiddle =
                this.buttonGroupPosition === ButtonGroupPosition.MIDDLE;
            this.buttonGroupLast =
                this.buttonGroupPosition === ButtonGroupPosition.LAST;
        }
    };
    return ButtonComponent;
}());
export { ButtonComponent };



// WEBPACK FOOTER //
// ./src/app/@shared/ui/button/button.component.ts.pre-build-optimizer.js